import React from 'react';
import { Button, Colors } from '../../../ui';
import { Position } from '../../../ui/Position';
import { FlexScroller } from '../../../ui/Scrollers';
import { useOnCreateTeam } from '../../actions/WorkspaceActions';
import { useResolve } from '../../Container';
import { Divider, Flexer } from '../../dashboard/elements/LayoutElements';
import { AccountModel } from '../AccountModel';
import { AccountBlock } from './AccountBlock';
import { AdvertBlock } from './AdvertBlock';
import { HelpVideoBlock } from './HelpVideoBlock';
import { Navigation } from './Navigation';
import { NoWorkspaceBlock } from './NoWorkspaceBlock';
import { UserBlock } from './UserBlock';
import { UserMenuBlock } from './UserMenuBlock';
import { WorkspaceMenuBlock } from './WorkspaceMenuBlock';
import { WorkspaceSelectorBlock } from './WorkspaceSelectorBlock';

const Or = () =>
    <Flexer relative>
        <Divider mode="horizontal" />
        <Position at="center">
            <Flexer background="white" padding=".25" color={Colors.textLight}>
                OR
            </Flexer>
        </Position>
    </Flexer>;

export const NewNavigationView = () => {

    const account = useResolve(AccountModel);
    const hasAnyTeams = account.workspaces.some(x => x.type === 'team' || x.type === 'user');
    const hasTeam = account.workspaces.find(x => x.type === 'team' || x.type === 'user');
    const { canCreateWorkspace, onCreateWorkspace } = useOnCreateTeam();

    return <Navigation>
        <Navigation.Section>
            <AccountBlock />
            <UserMenuBlock />
        </Navigation.Section>
        <Navigation.Divide />
        <Navigation.Section grow>
            {!hasAnyTeams && <NoWorkspaceBlock />}
            {hasAnyTeams && <WorkspaceSelectorBlock />}
            {!hasAnyTeams && canCreateWorkspace && <>
                <Or />
                <Flexer flex="row" center>
                    <Button variant="primary" onAction={onCreateWorkspace}>Create a new team</Button>
                </Flexer>
            </>}
            {hasTeam &&
                <FlexScroller>
                    <WorkspaceMenuBlock />
                </FlexScroller>
            }
        </Navigation.Section>
        <Navigation.Advert>
            <HelpVideoBlock />
        </Navigation.Advert>
        <Navigation.Advert>
            <AdvertBlock />
        </Navigation.Advert>
        <Navigation.Divide />
        <Navigation.Section end>
            <UserBlock />
        </Navigation.Section>
    </Navigation>;
};
